const COMPONENT_NAME = "List";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error:`;
const SUPPORTED_VARIANTS = [
  "SimpleList",
  "OrderedList",
  "UnorderedList",
  "InlineList",
  "DividedInlineList",
  "ExpandableList"
];
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR,
  SUPPORTED_VARIANTS
};
